import { useNavigate, useSearch } from '@tanstack/react-router'
import { useCallback } from 'react'

import { useSessionManager } from '../session.ts'

import { useAsyncCallback } from '#/lib/hooks/use-async-callback.ts'

// await logout first to clean the session and redirect only after that, otherwise login page will redirect to the app
export const useDisconnect = (): (() => void) => {
  const sessionManager = useSessionManager()
  const navigate = useNavigate()
  // Someone who signed in through a partner gets that partner's login page back, not the email form
  const sso = useSearch({ strict: false }).sso

  // The redirect runs inside the callback: logging out unmounts the components that hold the logout button,
  // so an effect scheduled here would never fire
  return useAsyncCallback(
    useCallback(async () => {
      await sessionManager.logout()
      await navigate({ to: '/login', search: sso ? { sso } : {} })
    }, [sessionManager, navigate, sso]),
  )
}
